import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { contact } from '../../data/site';
export function Hero() {
  const reduce = useReducedMotion();
  return <section className="mx-auto grid max-w-7xl items-center gap-12 px-6 pb-20 pt-14 md:pt-20 lg:grid-cols-12 lg:gap-16 lg:px-10 lg:pb-28" data-id="element-31" data-mp="jn5emkzjehvo">
      <motion.div initial={reduce ? false : {
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="lg:col-span-7" data-id="element-32" data-mp="aotosl6hvo4a">
        <h1 className="font-display text-5xl font-medium leading-[1.02] tracking-tight text-ink sm:text-6xl lg:text-[5.5rem]" data-id="element-33" data-mp="r5gesfyui3n">
          Le violoncelle,
          <br data-id="element-34" data-mp="1v4exb5aud5vx" />
          joué avec <em className="font-normal italic text-wood" data-id="element-35" data-mp="1v4n9sw31y96l">le corps</em>
          <br data-id="element-36" data-mp="1q5akm4opkq0u" />
          tout entier.
        </h1>
        <p className="mt-8 max-w-xl text-lg leading-relaxed text-ink-soft" data-id="element-37" data-mp="1q6los5m2fzsh">
          Elisabete Costa enseigne le violoncelle et accompagne les musiciens vers un jeu plus libre,
          plus sûr et sans douleur — de la première note aux grandes scènes.
        </p>
        <div className="mt-10 flex flex-wrap items-center gap-x-8 gap-y-4" data-id="element-38" data-mp="1cyoe9do8dxee">
          <Link to="/contact" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-wood px-7 py-3.5 text-sm font-medium text-paper transition-colors duration-150 hover:bg-wood-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-wood focus-visible:ring-offset-4 focus-visible:ring-offset-paper" data-id="element-39" data-mp="1hx9hzn2oyz7l">
            Réserver un premier cours
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-40" data-mp="20vu759l0vuil" />
          </Link>
          <a href="#methode" className="whitespace-nowrap border-b border-ink/40 pb-0.5 text-sm font-medium text-ink transition-colors duration-150 hover:border-wood hover:text-wood" data-id="element-41" data-mp="2oloh9jdyj4z5">
            Découvrir la méthode
          </a>
        </div>
      </motion.div>

      <motion.figure initial={reduce ? false : {
      opacity: 0,
      scale: 0.98
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.3,
      delay: 0.06,
      ease: [0.23, 1, 0.32, 1]
    }} className="lg:col-span-5" data-id="element-42" data-mp="2y9akap6aok96">
        <div className="relative mx-auto max-w-md lg:ml-auto" data-id="element-43" data-mp="2p7kkow29ef0b">
          <div className="absolute -bottom-4 -left-4 h-full w-full rounded-sm bg-paper-deep" aria-hidden="true" data-id="element-44" data-mp="2k998wfselufg" />
          <img src={contact.portrait} alt="Elisabete Costa souriante, son violoncelle dans les bras" className="relative aspect-square w-full rounded-sm object-cover" data-id="element-45" data-mp="2fiaslg7f0wc7" />
        </div>
        <figcaption className="mx-auto mt-8 flex max-w-md items-baseline justify-between gap-4 text-sm lg:ml-auto" data-id="element-46" data-mp="26jfm030glk8d">
          <span className="font-medium text-ink" data-id="element-47" data-mp="21i9m9l8dswpc">Elisabete Costa</span>
          <span className="text-right text-ink-soft" data-id="element-48" data-mp="1wkztpwpp44xa">Violoncelle · Performance · Santé</span>
        </figcaption>
      </motion.figure>
    </section>;
}